import { create } from 'zustand';

export type SidebarPanel = 'channels' | 'dm' | 'secret' | 'friends' | 'browse';

interface SidebarPanelState {
  panel: SidebarPanel;
  setPanel: (p: SidebarPanel) => void;
}

/**
 * Phase 21.3 (redesign) — активная вкладка сайдбара (Каналы/Друзья/Секрет/…).
 * Поднято в shared-store, чтобы вкладки можно было рендерить в TopBar
 * (над чатом), а список — в левой колонке.
 */
export const useSidebarPanelStore = create<SidebarPanelState>((set) => ({
  panel: 'channels',
  setPanel: (p) => set({ panel: p }),
}));
